import { render, staticRenderFns } from "./StepsNavSimple.vue?vue&type=template&id=080816fa"
import script from "./StepsNavSimple.vue?vue&type=script&lang=js"
export * from "./StepsNavSimple.vue?vue&type=script&lang=js"
import style0 from "./StepsNavSimple.vue?vue&type=style&index=0&id=080816fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports